import { Link } from "react-router-dom";
function Schoolchoir() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active">School Choir</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3 facilities_section_imgs">
          <div class="col-lg-12">
            <h1> School Choir </h1>
            <p>
              A school choir offers students the chance to develop vocal skills,
              musical expression, and teamwork through regular rehearsals and
              performances, fostering confidence, discipline, and a sense of
              community while enriching school events with harmonious and
              creative musical presentations.
            </p>
          </div>
        </div>
        <br />

        <div className="row g-3 facilities_section_imgs">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Schoolchoir_1.JPG"
              alt="Frank Anthony Bangalore"
              className="img-fluid schoolchoir"
            />
          </div>

          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Schoolchoir_2.JPG"
              alt="Frank Anthony Bangalore"
              className="img-fluid schoolchoir"
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default Schoolchoir;
